import React, { useEffect } from "react";
import loginImage from "../../assets/images/tiglobal.png";
import styles from "./govCo.module.css";

// Declaración global para que TypeScript reconozca window.initChatbot
declare global {
  interface Window {
    initChatbot?: (containerId: string, options?: Record<string, any>) => void;
  }
}
const WIDGET_URL = process.env.REACT_APP_WIDGET_URL;
const WIDGET_ID = process.env.REACT_APP_WIDGET_ID;
const TiglobalPage: React.FC = () => {
  useEffect(() => {
    // Cargar CSS del chatbot si no está presente
    const linkId = "chatbot-widget-style";
    if (!document.getElementById(linkId)) {
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = `${WIDGET_URL}/chatbot-widget.css`;
      document.head.appendChild(link);
    }

    // Cargar script del chatbot si no está presente
    const scriptId = "chatbot-widget-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = `${WIDGET_URL}/widget.umd.js`;
      script.async = true;
      script.onload = () => {
        window.initChatbot?.("root-widget", {
          userName: "Visitante Gov.co",
          widgetId: WIDGET_ID,
        });
      };
      document.body.appendChild(script);
    } else {
      // Si ya está cargado, inicializar directamente
      window.initChatbot?.("root-widget", {
        userName: "Visitante Gov.co",
        widgetId: WIDGET_ID,
      });
    }

    // Limpieza al desmontar el componente
    return () => {
      const widgetDiv = document.getElementById("root-widget");
      if (widgetDiv) widgetDiv.innerHTML = "";
    };
  }, []);

  return (
    <div className={styles.fullscreen}>
      <img src={loginImage} alt="Fondo" className={styles.bgImage} />
      <div id="root-widget" />
    </div>
  );
};

export default TiglobalPage;
